export function formatBarsBeats(beat: number, beatsPerBar = 4): string {
  const bar = Math.floor(beat / beatsPerBar) + 1;
  const b = Math.floor(beat % beatsPerBar) + 1;
  const tick = Math.floor((beat - Math.floor(beat)) * 96);
  return `${bar}.${b}.${String(tick).padStart(3, '0')}`;
}

export function sessionKey(trackId: string, sceneIdx: number): string {
  return `${trackId}::${sceneIdx}`;
}

export function clsx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
